import CustomLandingPage from './custom-landing-page';
export default CustomLandingPage;